import 'tempusdominus-bootstrap-4/build/js/tempusdominus-bootstrap-4';

const showRecurringMaintenanceFields = function () {
  $("#scheduled_maintenance_recurring_maintenance_true[type='radio']").on(
    'change',
    function () {
      if (
        $('#scheduled_maintenance_recurring_maintenance_true').is(':checked')
      ) {
        $('.recurring_maintenance_fields').show();
        $('.non_recurring_maintenance_fields').hide();
      } else {
        $('.recurring_maintenance_fields').hide();
        $('.non_recurring_maintenance_fields').show();
      }
    }
  );
};

const showNonRecurringMaintenanceFields = function () {
  $("#scheduled_maintenance_recurring_maintenance_false[type='radio']").on(
    'change',
    function () {
      if (
        $('#scheduled_maintenance_recurring_maintenance_false').is(':checked')
      ) {
        $('.recurring_maintenance_fields').hide();
        $('.non_recurring_maintenance_fields').show();
      } else {
        $('.recurring_maintenance_fields').show();
        $('.non_recurring_maintenance_fields').hide();
      }
    }
  );
};

const getFrequencyPeriod = function (frequencyPeriodId, frequencyQuantity) {
  const frequencyPeriodMap = {
    1: 'hora',
    2: 'día',
    4: 'mes',
    5: 'año',
  };

  const frequencyPeriod = frequencyPeriodMap[frequencyPeriodId];
  let pluralSuffix = '';

  if (frequencyPeriod === 'mes' && frequencyQuantity > 1) {
    pluralSuffix = 'es';
  } else if (frequencyQuantity > 1) {
    pluralSuffix = 's';
  }

  return `${frequencyPeriod}${pluralSuffix}`;
};

const displayFrequencyQuantity = function () {
  const frequencyQuantity = $(
    '#scheduled_maintenance_frequency_quantity'
  ).val();
  const frequencyPeriodId = $(
    '#scheduled_maintenance_frequency_period_id'
  ).val();

  if (
    frequencyPeriodId === '' ||
    frequencyPeriodId === undefined ||
    frequencyPeriodId === null ||
    frequencyQuantity === ''
  ) {
    $('.frequency_quantity_text').text('');
  } else if (frequencyQuantity === '1') {
    $('.frequency_quantity_text').text('Cada ');
  } else if (frequencyQuantity !== '') {
    $('.frequency_quantity_text').text(`Cada ${frequencyQuantity}`);
  }
};

const displayFrequencyPeriod = function () {
  const frequencyPeriodId = $(
    '#scheduled_maintenance_frequency_period_id'
  ).val();
  const frequencyQuantity = $(
    '#scheduled_maintenance_frequency_quantity'
  ).val();

  if (frequencyPeriodId !== '' && frequencyQuantity !== '') {
    const frequencyPeriod = getFrequencyPeriod(
      frequencyPeriodId,
      frequencyQuantity
    );
    $('.frequency_period_text').text(frequencyPeriod);
  } else {
    $('.frequency_period_text').text('');
  }
};

// Called on form submit. Returns false if a visible recurrinng maintenance field is empty.
const validRecurringMaintenanceFields = function () {
  const periodId = $('#scheduled_maintenance_frequency_period_id').val();
  const frequencyQuantity = $(
    '#scheduled_maintenance_frequency_quantity'
  ).val();
  const min = $('#scheduled_maintenance_min').val().trim();
  const hour = $('#scheduled_maintenance_hour').val().trim();
  const monthHour = $('#scheduled_maintenance_month_hour').val().trim();
  const monthDay = $('#scheduled_maintenance_month_day').val().trim();
  const yearHour = $('#scheduled_maintenance_year_hour').val().trim();
  const yearDay = $('#scheduled_maintenance_year_day').val().trim();
  const yearMonth = $('#scheduled_maintenance_year_month').val().trim();
  let validFields = true;
  if (frequencyQuantity.length === 0) {
    validFields = false;
  }
  switch (periodId) {
    case '1':
      if (min.length === 0) {
        validFields = false;
      }
      break;
    case '2':
      if (hour.length === 0) {
        validFields = false;
      }
      break;
    case '4':
      if (monthHour.length === 0 || monthDay.length === 0) {
        validFields = false;
      }
      break;
    case '5':
      if (
        yearHour.length === 0 ||
        yearDay.length === 0 ||
        yearMonth.length === 0
      ) {
        validFields = false;
      }
      break;
    default:
  }
  return validFields;
};

const clearHiddenRecurringMaintenanceFields = function () {
  const periodId = $('#scheduled_maintenance_frequency_period_id').val();
  const min = $('#scheduled_maintenance_min');
  const hour = $('#scheduled_maintenance_hour');
  const monthHour = $('#scheduled_maintenance_month_hour');
  const monthDay = $('#scheduled_maintenance_month_day');
  const yearHour = $('#scheduled_maintenance_year_hour');
  const yearDay = $('#scheduled_maintenance_year_day');
  const yearMonth = $('#scheduled_maintenance_year_month');

  switch (periodId) {
    case '1':
      hour.val('');
      monthHour.val('');
      monthDay.val('');
      yearHour.val('');
      yearDay.val('');
      yearMonth.val('');
      break;
    case '2':
      min.val('');
      monthHour.val('');
      monthDay.val('');
      yearHour.val('');
      yearDay.val('');
      yearMonth.val('');
      break;
    case '4':
      min.val('');
      hour.val('');
      yearHour.val('');
      yearDay.val('');
      yearMonth.val('');
      break;
    case '5':
      min.val('');
      hour.val('');
      monthHour.val('');
      monthDay.val('');
      break;
    default:
      min.val('');
      hour.val('');
      monthHour.val('');
      monthDay.val('');
      yearHour.val('');
      yearDay.val('');
      yearMonth.val('');
  }
};

document.addEventListener('turbolinks:load', function () {
  $('.recurring_maintenance_fields').hide();
  $('.non_recurring_maintenance_fields').hide();
  if ($('#scheduled_maintenance_recurring_maintenance_true').is(':checked')) {
    $('.recurring_maintenance_fields').show();
    displayFrequencyQuantity();
    displayFrequencyPeriod();
  }
  if ($('#scheduled_maintenance_recurring_maintenance_false').is(':checked')) {
    $('.non_recurring_maintenance_fields').show();
  }

  $('#scheduled_maintenance_recurring_maintenance_true').on(
    'click',
    showRecurringMaintenanceFields
  );
  $('#scheduled_maintenance_recurring_maintenance_false').on(
    'click',
    showNonRecurringMaintenanceFields
  );

  /* * ************ Date Pickers ************* */

  // Scheduled date picker
  $('.maintenance_scheduled_date_picker').daterangepicker({
    autoUpdateInput: false,
    singleDatePicker: true,
    timePicker: true,
    showDropdowns: true,
    locale: {
      applyLabel: 'Aplicar',
      cancelLabel: 'Cancelar',
      format: 'YYYY-MM-DD h:mm A',
    },
  });
  $('.maintenance_scheduled_date_picker').on(
    'apply.daterangepicker',
    function (ev, picker) {
      $(this).val(picker.startDate.format('YYYY-MM-DD h:mm A'));
    }
  );
  $('.maintenance_scheduled_date_picker').on(
    'cancel.daterangepicker',
    function () {
      $(this).val('');
    }
  );
  // Start date picker
  $('.scheduled_maintenance_start_date').daterangepicker({
    autoUpdateInput: $('.scheduled_maintenance_start_date').val() === '',
    singleDatePicker: true,
    timePicker: true,
    showDropdowns: true,
    drops: 'up',
    minDate: moment(),
    maxDate: moment().add(2, 'years'),
    locale: {
      applyLabel: 'Aplicar',
      cancelLabel: 'Cancelar',
      format: 'YYYY-MM-DD h:mm A',
    },
  });
  $('.scheduled_maintenance_start_date').on(
    'apply.daterangepicker',
    function (ev, picker) {
      $(this).val(picker.startDate.format('YYYY-MM-DD h:mm A'));
    }
  );
  // End date picker
  $('.scheduled_maintenance_end_date').daterangepicker({
    autoUpdateInput: false,
    singleDatePicker: true,
    timePicker: true,
    showDropdowns: true,
    drops: 'up',
    startDate: moment().endOf('day'),
    minDate: moment(),
    locale: {
      applyLabel: 'Aplicar',
      cancelLabel: 'Cancelar',
      format: 'YYYY-MM-DD h:mm A',
    },
  });
  $('.scheduled_maintenance_end_date').on(
    'apply.daterangepicker',
    function (ev, picker) {
      $(this).val(picker.startDate.format('YYYY-MM-DD h:mm A'));
    }
  );
  $('.scheduled_maintenance_end_date').on(
    'cancel.daterangepicker',
    function () {
      $(this).val('');
    }
  );
  // Minute picker
  $('.minute-picker').datetimepicker({
    format: 'mm',
    useCurrent: false,
    buttons: {
      showToday: true,
      showClose: true,
    },
    tooltips: {
      today: 'Seleccionar minuto actual',
      close: 'Cerrar',
      incrementMinute: 'Minuto siguiente',
      pickMinute: 'Escorger minuto',
      decrementMinute: 'Minuto anterior',
    },
    toolbarPlacement: 'bottom',
    icons: {
      time: 'fas fa-clock',
      date: 'fas fa-calendar',
      up: 'fas fa-lg fa-angle-up text-orange',
      down: 'fas fa-lg fa-angle-down text-orange',
      previous: 'fas fa-chevron-left',
      next: 'fas fa-chevron-right',
      today: 'fas fa-clock text-blue',
      close: 'fas fa-times text-red',
      clear: 'fas fa-trash text-red',
    },
  });
  // Day picker
  $('.day-picker').datetimepicker({
    format: 'DD',
    viewMode: 'days',
    buttons: {
      showToday: true,
      showClose: true,
    },
    tooltips: {
      today: 'Seleccionar día actual',
      close: 'Cerrar',
    },
    showClear: true,
    toolbarPlacement: 'bottom',
    icons: {
      today: 'fas fa-calendar text-blue',
      close: 'fas fa-times text-red',
    },
  });
  // Month picker
  $('.month-picker').datetimepicker({
    format: 'MMMM',
    viewMode: 'months',
    minViewMode: 'months',
    buttons: {
      showToday: true,
      showClose: true,
    },
    tooltips: {
      today: 'Seleccionar mes actual',
      close: 'Cerrar',
    },
    showClear: true,
    toolbarPlacement: 'bottom',
    icons: {
      date: 'fas fa-calendar',
      today: 'fas fa-calendar text-blue',
      close: 'fas fa-times text-red',
    },
  });

  // Maintenance frequency
  $('.frequency-periods').hide();
  if ($('.frequency-period-dropdown').val()) {
    $(`.${$('.frequency-period-dropdown').val()}`).show();
  }
  $('.frequency-period-dropdown').on('change', function () {
    $('.frequency-periods').hide();
    if ($(this).val() !== '') {
      $(`.${$(this).val()}`).show();
    } else {
      $('.frequency-periods').hide();
    }
  });

  $('#scheduled_maintenance_frequency_quantity').on('change', function () {
    displayFrequencyQuantity();
    displayFrequencyPeriod();
  });
  $('#scheduled_maintenance_frequency_quantity').on('keyup', function () {
    displayFrequencyQuantity();
    displayFrequencyPeriod();
  });
  $('#scheduled_maintenance_frequency_quantity').on('change', function () {
    displayFrequencyPeriod();
    displayFrequencyQuantity();
  });
  $('#scheduled_maintenance_frequency_quantity').on('keyup', function () {
    displayFrequencyPeriod();
    displayFrequencyQuantity();
  });
  $('#scheduled_maintenance_frequency_period_id').on('change', function () {
    displayFrequencyPeriod();
    displayFrequencyQuantity();
  });
  $('#scheduled_maintenance_checklist_id').select2({
    allowClear: true,
    placeholder: 'Seleccione una opción',
    width: '100%',
  });
  $('#work_order_checklist_id').select2({
    allowClear: true,
    placeholder: 'Seleccione una opción',
    width: '100%',
  });
  $('#clear_scheduled_date_btn').on('click', function () {
    $('#scheduled_maintenance_scheduled_date').val('');
  });
  $('#clear_recurring_maintenance_start_date_btn').on('click', function () {
    $('#scheduled_maintenance_start_date').val('');
  });
  $('#clear_recurring_maintenance_end_date_btn').on('click', function () {
    $('#scheduled_maintenance_end_date').val('');
  });

  // Validate and clear unwanted fields in form submission (#new and #edit)
  $('.new_scheduled_maintenance').on('submit', function () {
    if ($('#scheduled_maintenance_recurring_maintenance_true').is(':checked')) {
      if (validRecurringMaintenanceFields() === false) {
        alert(
          'Debes llenar los campos respectivos para programar el mantenimiento.'
        );
        return false;
      }
      $('#scheduled_maintenance_scheduled_date').val('');
      clearHiddenRecurringMaintenanceFields();
    }
    if (
      $('#scheduled_maintenance_recurring_maintenance_false').is(':checked')
    ) {
      $('div.recurring_maintenance_fields :input').val('');
      $('div.frequency-periods :input').val('');
      $('.scheduled_maintenance_start_date').val('');
      $('.scheduled_maintenance_end_date').val('');
    }
  });
  $('.edit_scheduled_maintenance').on('submit', function () {
    if ($('#scheduled_maintenance_recurring_maintenance_true').is(':checked')) {
      if (validRecurringMaintenanceFields() === false) {
        alert(
          'Debes llenar los campos respectivos para programar el mantenimiento.'
        );
        return false;
      }
      $('#scheduled_maintenance_scheduled_date').val('');
      clearHiddenRecurringMaintenanceFields();
    }
    if (
      $('#scheduled_maintenance_recurring_maintenance_false').is(':checked')
    ) {
      $('div.recurring_maintenance_fields :input').val('');
      $('div.frequency-periods :input').val('');
      $('.scheduled_maintenance_start_date').val('');
      $('.scheduled_maintenance_end_date').val('');
    }
  });
});
